"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var product_1 = require("../../ducks/product");
var withErrorBoundary_1 = __importDefault(require("../../../../decorators/withErrorBoundary"));
var ProductCards_1 = __importDefault(require("../../../common/ProductCards"));
var SiblingProducts = function () {
    var siblingProducts = (0, react_redux_1.useSelector)(product_1.siblingProductsSelector);
    return (react_1.default.createElement(ProductCards_1.default, { title: "\u0415\u0449\u0435 \u043E\u0442 \u044D\u0442\u043E\u0433\u043E \u0434\u0438\u0437\u0430\u0439\u043D\u0435\u0440\u0430", products: siblingProducts }));
};
exports.default = (0, withErrorBoundary_1.default)(SiblingProducts);
